import api from './client';

export const templateAPI = {
  getAll: async () => {
    const response = await api.get('/api/admin/license-templates');
    return response.data;
  },
};
